import { useEffect, useMemo, useRef, useState } from "react";
import { responseMsg } from "../common/ResponseMsg";
import Modal from "../common/Modal";
import ContentModal from "./ContentModal";
import DetailComponent from "./DetailComponent";
import DetailComponentNew from "./DetailComponentNew";
import DetailSearchWrap from "./DetailSearchWrap"
import { useSearchParams } from 'react-router-dom';
import Text from "../../shared/components/Text";
import ManageButton from "../../shared/components/ManageButton";
import useDevice from "../../shared/hooks/useDevice";
import Flex from "../../shared/components/Flex";
import MainComponent from "./MainComponent";
import Spacer from "../../shared/components/Spacer";
import ChoiceModal from "./ChoiceModal";
import ScrollModal from "../common/ScrollModal";
import { addTooltipField } from "../../shared/utils/gridTitleUtil";
import { useAlert } from "../../shared/components/AlertProvider";
import Loading from "../../shared/components/Loading";
import useDelayedLoading from "../../shared/hooks/useDelayedLoading";

function Sensor({ name }) {
    const [render, setRender] = useState(false);
    const [searchObj, setSearchObj] = useState({ req: { address: "", department: "", startDate: "", endDate: "" } });
    const [sensor, setSensor] = useState();
    const [modalTitle, setModalTitle] = useState();
    const [modalOption, setModalOption] = useState({});
    const [modalSize, setModalSize] = useState();
    const [showDetail, setShowDetail] = useState(false); // 상세페이지 표출 여부
    const [showDetailNew, setShowDetailNew] = useState(false); // 상세페이지(신규) 표출 여부
    const [showChart, setShowChart] = useState(false); // 제품 상세페이지 차트, 테이블 표출 여부
    const [selectedRow, setSelectedRow] = useState(); // 상세보기시 선택된 제품
    const [regions, setRegions] = useState([]); // 지역권한 리스트
    const [LogSearchProps, setLogSearchProps] = useState({});
    const [detailGrid, setDetailGrid] = useState();
    const [excelHeaders, setExcelHeaders] = useState();
    const [pagination, setPagination] = useState();
    const [sort, setSort] = useState(null);
    const [searchParams, setSearchParams] = useSearchParams();
    const [choiceModalOption, setChoiceModalOption] = useState({});
    const device = useDevice();
    const isMobile = device !== 'desktop';
    let lastTap = useRef(0);
    let lastIdx = useRef(null);
    const showAlert = useAlert();
    const [selectedRowImei, setSelectedRowImei] = useState(); // 상세보기시 선택된 제품

    const componetRendering = () => {
        setRender(!render);
    }

    const apiGetSearchSensor = (page) => {
        let url = '/api/system/sensors/paging?'
        const pagingSize = 20;

        if (page) {
            url += `page=${page - 1}&`
            url += `size=${pagingSize}&`
        }
        if (sort) {
            url += `sort=${sort}&`;
        }
        setSelectedRowImei(null);
        if (searchObj) {
            Object.keys(searchObj.req).forEach(ele => {
                if (searchObj.req[ele]) {
                    url += `${ele}=${searchObj.req[ele]}&`
                }
            })

            fetch(url, {
                method: "GET",
            })
                .then((res) => res.json())
                .then((json) => {
                    if (json.code === responseMsg.SUCCESS.code) {
                        setSensor(json.data);
                        setPagination(json.pagination);

                    } else if (json.code === responseMsg.FAIL.code) {
                        showAlert({ title: "오류", text: "통신이 지연되고 있습니다..", type: "error" })
                    }
                })
                .catch((error) => {
                    showAlert({ title: "오류", text: "정상적으로 처리되지 않았습니다.", type: "error" })
                });
        }
    }

    // getSensorList
    useEffect(() => {
        const paramIMEI = searchParams.get("IMEI")

        if (paramIMEI) {
            fetch(`/api/system/sensors/${paramIMEI}`, {
                method: "GET",
            })
                .then((res) => res.json())
                .then((json) => {
                    if (json.code === responseMsg.SUCCESS.code) {
                        setSelectedRow(json.data);

                        // 신규 추가된 데이터의 경우 신규 화면으로 이동하도록 할 것
                        if (json.data.isNew === "Y") {
                            setShowDetailNew(true);
                        } else {
                            setShowDetail(true);
                        }

                    } else if (json.code === responseMsg.FAIL.code) {
                        showAlert({ title: "오류", text: "통신이 지연되고 있습니다..", type: "error" })
                    }
                })
                .catch((error) => {
                    showAlert({ title: "오류", text: "정상적으로 처리되지 않았습니다.", type: "error" })
                });

        } else {
            apiGetSearchSensor(1);
        }

    }, [render, searchObj, sort])

    // getRegionList
    useEffect(() => {
        fetch("/api/system/codes/REGION", {
            method: "GET"
        })
            .then((res) => res.json())
            .then((json) => {
                if (json.code === responseMsg.SUCCESS.code) {
                    setRegions(json.data)
                }
            })
    }, [render])

    /* 항목 검색시 테이블 렌더링 */
    // 컬럼 기본 옵션 (sort 상태에 따라 정렬 방향 반영)
    const baseColumnDefs = [
        { headerName: '관리번호', field: 'manageCd', flex: 0.2, sortable: true, unSortIcon: true, minWidth: 200 },
        { headerName: '지역', field: 'region.name', flex: 0.2, sortable: false, minWidth: 250, cellRenderer: ({ data }) => `${data.region.parentCode.name}[${data.region.name}]` },
        { headerName: '주소', field: 'address', flex: 0.2, sortable: false, minWidth: 200 },
        { headerName: '부서', field: 'department', flex: 0.1, sortable: false, minWidth: 100 },
        { headerName: '설치일', field: 'installDt', flex: 0.2, sortable: true, unSortIcon: true, minWidth: 200 },
        { headerName: 'IMEI', field: 'imei', flex: 0.2, sortable: false, minWidth: 200 },
    ];
    const columnDefs = useMemo(() => {
        if (!sort) {
            return addTooltipField(baseColumnDefs.map(col => ({ ...col, sort: undefined })));
        }
        const [field, direction] = sort.split(',');
        return addTooltipField(baseColumnDefs.map(col =>
            col.field === field ? { ...col, sort: direction } : { ...col, sort: undefined }
        ));
    }, [sort]);

    // 테이블 옵션
    const gridConfig = {
        columnDefs: columnDefs,
        rowData: sensor,
        onPageChange: apiGetSearchSensor,
        pagination: pagination,
        onCellClicked: (cell) => onCellMobileClick(cell),
        onCellDoubleClicked: (cell) => onOpenChoiceModal(cell),
        selectedRowImei: selectedRowImei,
        setSelectedRowImei: setSelectedRowImei,
        onSortChanged: (event) => {
            if (!event.api) return;
            const sorted = event.api.getColumnState().filter(s => s.sort != null);
            if (sorted.length) {
                setSort(`${sorted[0].colId},${sorted[0].sort}`);
            } else {
                setSort(null);
            }
        }
    }

    const onCellMobileClick = (cell) => {
        if (isMobile) {
            const now = Date.now();
            const tapInterval = now - lastTap.current;
            if (tapInterval < 300 && lastIdx.current === cell.rowIndex) {
                onOpenChoiceModal(cell);
                lastIdx.current = null;
                return;
            }
            lastTap.current = now;
            lastIdx.current = cell.rowIndex;
        }
    }

    /* 모달 */
    // insert modal open
    const onOpenChoiceModal = (cell) => {
        setChoiceModalOption({
            ...modalOption,
            open: true,
            close: closeChoiceModal,
            main: <ChoiceModal
                sensor={cell.data}
                openDetailModal={() => {
                    setSelectedRow(cell.data);
                    if (cell.data.isNew === "Y") {
                        setShowDetail(false);
                        setShowDetailNew(true);
                    } else {
                        setShowDetail(true);
                        setShowDetailNew(false);
                    }
                }}
                openUpdateModal={() => {
                    cellClickedListener(cell);
                }}
                close={closeChoiceModal}
            />
        })
    };

    // modal close
    const closeChoiceModal = () => {
        setChoiceModalOption({
            ...modalOption,
            open: false,
        });
    };

    const onOpenModal = () => {

        setModalTitle("제품관리");
        setModalSize("modal-lg");
        setModalOption({
            ...modalOption,
            open: true,
            close: closeModal,
            main: <ContentModal mode={"insert"} close={closeModal} regions={regions} rendering={componetRendering} />
        })
    };

    // modal close
    const closeModal = () => {
        setModalOption({
            ...modalOption,
            open: false,
        });
    };

    // update modal open
    const cellClickedListener = (cell) => {
        if (cell.colDef.field === '') { return }
        setModalTitle("제품관리");
        setModalSize("modal-lg");
        setModalOption({
            ...modalOption,
            open: true,
            close: closeModal,
            main: <ContentModal mode={"update"} data={cell.data} close={closeModal} regions={regions} rendering={componetRendering} />
        })
    };

    /* 기타기능 */
    // 뒤로가기
    const comeback = () => {
        setShowDetail(false);
        setShowDetailNew(false);
        setShowChart(false);
        setSearchObj({ req: { address: "", department: "", startDate: "", endDate: "" } });
        setSearchParams({});
        setExcelHeaders(null); // excelHeaders 초기화
        apiGetSearchSensor(1);
    }

    const isLoadingComponent = useDelayedLoading(500);

    return (
        <>
            <Loading isLoading={isLoadingComponent} minDuration={300} message="Loading..." />
            <div className="contents" style={{ backgroundColor: "#F9FAFC", userSelect: "none" }}>
                <Flex alignItems="center" justifyContent="space-between">
                    <Text size={'xl'} weight={'bold'} onClick={() => window.location.href = '/sensor'}>제품현황</Text>
                    <Flex gap={5}>
                        {
                            showDetail || showDetailNew ? null : (
                                <div style={{ display: "flex", gap: 3, height: isMobile ? "41px" : "34px" }}>
                                    <ManageButton
                                        onClick={() => apiGetSearchSensor(1)}
                                        btnType='search'
                                    />
                                    <ManageButton onClick={onOpenModal} btnType='regist' />
                                </div>
                            )
                        }
                    </Flex>
                </Flex>

                <Spacer direction="vertical" size={10} />

                <div className="page_contents">
                    <div className={`sensor_content`}>
                        {!showDetail && !showDetailNew && <MainComponent
                            grid={gridConfig}
                            search={{ searchSetter: setSearchObj }}
                        />}

                        {showDetail && <DetailComponent
                            data={selectedRow}
                            showChart={showChart}
                            searchProps={LogSearchProps}
                            setDetailGrid={setDetailGrid}
                            setExcelHeaders={setExcelHeaders}
                            customBtnWrap={<DetailSearchWrap
                                selectedRow={selectedRow}
                                comeback={comeback}
                                setShowChart={setShowChart}
                                showChart={showChart}
                                setSearchProps={setLogSearchProps}
                                detailGrid={detailGrid}
                                excelHeaders={excelHeaders}
                            />}
                            block={true}
                        />}

                        {showDetailNew && <DetailComponentNew
                            data={selectedRow}
                            showChart={showChart}
                            searchProps={LogSearchProps}
                            setDetailGrid={setDetailGrid}
                            customBtnWrap={<DetailSearchWrap
                                selectedRow={selectedRow}
                                comeback={comeback}
                                setShowChart={setShowChart}
                                showChart={showChart}
                                setSearchProps={setLogSearchProps}
                                detailGrid={detailGrid}
                            />}
                            block={true}
                        />}
                    </div>
                </div>

                <Modal
                    headerText="알림"
                    size="300px"
                    animationType="bottomTop"
                    modal={choiceModalOption}
                />

                <ScrollModal
                    headerText="제품관리"
                    size={"1150px"}
                    modal={modalOption}
                />
            </div>
        </>
    )
}

export default Sensor;